/**
 * Converts flat i18n messages (e.g. { "pages.Welcome.title": "Hello" }) to nested
 * format expected by Vue I18n setLocaleMessage (e.g. { pages: { Welcome: { title: "Hello" } } }).
 * If the object is already nested (no key contains "."), returns it as-is.
 */
export function flatToNestedMessages(
  flat: Record<string, unknown>
): Record<string, unknown> {
  const keys = Object.keys(flat);
  if (keys.length === 0) return flat;
  const hasDotKeys = keys.some((k) => k.includes("."));
  if (!hasDotKeys) return flat;

  const result: Record<string, unknown> = {};
  for (const key of keys) {
    const value = flat[key];
    const parts = key.split(".");
    let current: Record<string, unknown> = result;
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      if (!(part in current) || typeof current[part] !== "object" || current[part] === null) {
        current[part] = {};
      }
      current = current[part] as Record<string, unknown>;
    }
    current[parts[parts.length - 1]] = value;
  }
  return result;
}
